import { z } from 'zod';
/** Field types — mirrors the Prisma `FieldType` enum. */
export const fieldTypeSchema = z.enum([
    'text',
    'textarea',
    'number',
    'date',
    'select',
    'checkbox',
    'radio',
    'scale',
    'signature',
]);
export const formFieldInputSchema = z.object({
    label: z.string().min(1).max(500),
    fieldType: fieldTypeSchema.default('text'),
    position: z.number().int().nonnegative().optional(),
    required: z.boolean().optional(),
    // #54 - the Form Builder's autopopulation key, so opening a form to fill in the
    // EHR can pre-fill this field from the contact's demographics.
    dataKey: z.string().max(60).nullish(),
});
export const formCreateSchema = z.object({
    name: z.string().min(1).max(200),
    description: z.string().max(2000).nullish(),
    type: z.string().max(50).nullish(),
    fields: z.array(formFieldInputSchema).max(200).optional(),
});
// Update: all fields optional; `fields` present ⇒ full replace of the field set.
export const formUpdateSchema = formCreateSchema.partial();
//# sourceMappingURL=forms.js.map